import styled from "styled-components";

export const Style = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 20px;
    padding-bottom: 10px;
    background: #000;
  }
  .buttonWrap {
    display: flex;
    align-items: center;
    gap: 8px;
    h3 {
      font-size: 20px;
      line-height: 30px;
      font-weight: 400;
      color: #ffffff;
    }

    .logoButton {
      width: 80px;
      padding: 0;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
    .longButton {
      padding: 6px 14px;
      border-radius: 50px;
      border: 1px solid #555555;
      background: #262626;
      display: flex;
      align-items: center;
      color: #ffffff;
      font-size: 16px;
      line-height: 26px;
      font-weight: 400;
      gap: 8px;
      cursor: pointer;
      img {
        height: 22px;
      }
    }
  }
`;
